// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tooltip_wrapper__11vfv","content":"Tooltip_content__21Eof"};